/** The light-grey fill a timeline document card wears, shared by the card
 *  itself and its loading placeholder. The cluster card sits a step darker
 *  (`ServerTimelineCluster`). */
export const TIMELINE_DOCUMENT_CARD_FILL_CLASS = "bg-[#f7f7f8]";
